module.exports = __webpack_public_path__ + "img/2.cc32d516.png";